module.exports = __webpack_public_path__ + "img/logo-sankei-main.1639c7cc.png";